import { render } from "./SSOErrorPage.vue?vue&type=template&id=75282766&scoped=true"
import script from "./SSOErrorPage.vue?vue&type=script&lang=js"
export * from "./SSOErrorPage.vue?vue&type=script&lang=js"

import "./SSOErrorPage.vue?vue&type=style&index=0&id=75282766&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-75282766"

export default script